import React from 'react';

const CSeparator = () => {
    return <div>
        <hr  style={{ borderTop: "2px solid #121212" }}></hr>
    </div>
}

export default CSeparator